import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import VueGtag from "vue-gtag"
Vue.use(VueGtag, {
  config: { id: "UA-148710276-1" }
})

import Clipboard from 'v-clipboard'
Vue.use(Clipboard)

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

// import "vue-material-design-icons/styles.css"
// import 'vue-tel-input/dist/vue-tel-input.css'

import VueCarousel from 'vue-carousel'
Vue.use( VueCarousel )


import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
Vue.use(Datetime)

import device from "vue-device-detector"
Vue.use(device)

import VueSuglify from "vue-suglify"
Vue.component("suglify", VueSuglify)

const config = {
  apiKey: "AIzaSyDnT8ybQ89L7cRbTtcqFCYS3CCDs3_-G28",
  authDomain: "bluefaucet2020.firebaseapp.com",
  databaseURL: "https://bluefaucet2020.firebaseio.com",
  projectId: "bluefaucet2020",
  storageBucket: "bluefaucet2020.appspot.com",
  messagingSenderId: "548179680516",
  appId: "1:548179680516:web:4d738bdb5d7b021f7e0451",
  measurementId: "G-DX0PJ701NV"
}

// import * as Firebase from 'firebase'
import Firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/messaging'
import 'firebase/functions'
Firebase.initializeApp(config)
export const db = Firebase.firestore()
export const auth = Firebase.auth()
export const str = Firebase.storage()
export const fc = Firebase.functions()
export const firebase = Firebase

let msgr = null
if ( Firebase.messaging.isSupported() ) {
  msgr = Firebase.messaging()
  msgr.usePublicVapidKey('BMeDmXqLrZGLoUEYn7aRK-dRiEOpfIVU4vw1M-bvGVvUJUfS57FCGwulAS_h7ddbzcd8d5EzthdQ9BYOHC3vAvk')
}
export { msgr }

import VueFirestore from 'vue-firestore'
Vue.use( VueFirestore, { key: 'id' } )

import DefaultLayout from '@/layouts/default'
import BfActivate from '@/components/bf-activate'
import BfModal from '@/components/bf-modal'
import BfButton from '@/components/bf-button'
import BfDialog from '@/components/bf-dialog'
import BfDivider from '@/components/bf-divider'
import BfFlex from '@/components/bf-flex'
import BfGrid from '@/components/bf-grid'
import BfHeader from '@/components/bf-header'
import BfInput from '@/components/bf-input'
import BfLink from '@/components/bf-link'
import BfNav from '@/components/bf-nav'
import BfNotice from '@/components/bf-notice'
import BfOffer from '@/components/bf-offer'
import BfOverlay from '@/components/bf-overlay'
import BfSocialAuth from '@/components/bf-social-auth'
import BfTranslate from '@/components/bf-translate'
import BfWrapper from '@/components/bf-wrapper'
import RsvCal from '@/components/calendars/orders'
import RsvDtls from '@/components/rsv-dtls'
import RsvMsgs from '@/components/rsv-msgs'
import RsvStamp from '@/components/rsv-stamp'

Vue.component('blue-layout', DefaultLayout)
Vue.component('bf-activate', BfActivate)
Vue.component('bf-modal', BfModal)
Vue.component('bf-button', BfButton)
Vue.component('bf-dialog', BfDialog)
Vue.component('bf-divider', BfDivider)
Vue.component('bf-flex', BfFlex)
Vue.component('bf-grid', BfGrid)
Vue.component('bf-header', BfHeader)
Vue.component('bf-input', BfInput)
Vue.component('bf-link', BfLink)
Vue.component('bf-nav', BfNav)
Vue.component('bf-notice', BfNotice)
Vue.component('bf-offer', BfOffer)
Vue.component('bf-overlay', BfOverlay)
Vue.component('bf-social-auth', BfSocialAuth)
Vue.component('bf-translate', BfTranslate)
Vue.component('bf-wrapper', BfWrapper)
Vue.component('rsv-cal', RsvCal)
Vue.component('rsv-dtls', RsvDtls)
Vue.component('rsv-msgs', RsvMsgs)
Vue.component('rsv-stamp', RsvStamp)


import HomeIcon from 'vue-material-design-icons/HomeOutline'
import AboutIcon from 'vue-material-design-icons/InformationOutline'
import PdfIcon from 'vue-material-design-icons/AdobeAcrobat'
import NotificationsIcon from 'vue-material-design-icons/BellOutline'
import BusinessIcon from 'vue-material-design-icons/CurrencyUsd'
// import BackIcon from 'vue-material-design-icons/ArrayLeft'
import ProfileIcon from 'vue-material-design-icons/AccountOutline'
import SettingsIcon from 'vue-material-design-icons/SettingsOutline'
import SendIcon from 'vue-material-design-icons/Send'
import QrIcon from 'vue-material-design-icons/Qrcode'
import HelpIcon from 'vue-material-design-icons/HelpRhombusOutline'
import PurseIcon from 'vue-material-design-icons/WalletOutline'
import ScheduleIcon from 'vue-material-design-icons/CalendarMonthOutline'
import SearchIcon from 'vue-material-design-icons/Magnify'
import MicrophoneIcon from 'vue-material-design-icons/Microphone'
import FavIcon from 'vue-material-design-icons/Heart'
import BackIcon from 'vue-material-design-icons/ArrowLeftBoldOutline'
import ForwardIcon from 'vue-material-design-icons/ArrowRightBoldOutline'
import UpIcon from 'vue-material-design-icons/ArrowUp'
import MenuOpenIcon from 'vue-material-design-icons/Menu'
import MenuCloseIcon from 'vue-material-design-icons/Backburger'
import SignUpIcon from 'vue-material-design-icons/AccountPlus'
import SignInIcon from 'vue-material-design-icons/LoginVariant'
import SignOutIcon from 'vue-material-design-icons/LogoutVariant'
import EmailIcon from 'vue-material-design-icons/EmailVariant'
import PhoneIcon from 'vue-material-design-icons/PhoneOutline'
import SMSIcon from 'vue-material-design-icons/CellphoneText'
import PasswordIcon from 'vue-material-design-icons/LockOpen'
import ConfirmIcon from 'vue-material-design-icons/Lock'
import CloseIcon from 'vue-material-design-icons/Close'
import NewIcon from 'vue-material-design-icons/Plus'
import UploadIcon from 'vue-material-design-icons/Upload'
import SortIcon from 'vue-material-design-icons/Sort'
import DraggableIcon from 'vue-material-design-icons/Drag'
import DeleteIcon from 'vue-material-design-icons/DeleteOutline'
import RemoveIcon from 'vue-material-design-icons/Delete'
// import HelpIcon from 'vue-material-design-icons/Help'
import CollapseIcon from 'vue-material-design-icons/ArrowCollapse'
import RotateIcon from 'vue-material-design-icons/AxisZRotateClockwise'
import FacebookIcon from 'vue-material-design-icons/Facebook'
import TwitterIcon from 'vue-material-design-icons/Twitter'
import GoogleIcon from 'vue-material-design-icons/GooglePlus'
import MessengerIcon from 'vue-material-design-icons/Forum'
import ReferralIcon from 'vue-material-design-icons/AccountCardDetailsOutline'
import TranslateIcon from 'vue-material-design-icons/Translate'
import SaveIcon from 'vue-material-design-icons/ContentSaveAll'
import StarIcon from 'vue-material-design-icons/Star'
import AddressIcon from 'vue-material-design-icons/MapMarker'
import WebIcon from 'vue-material-design-icons/Web'
import DeviceIcon from 'vue-material-design-icons/CellphoneWireless'
import TitleIcon from 'vue-material-design-icons/RenameBox'
import PrevIcon from 'vue-material-design-icons/ChevronLeft'
import NextIcon from 'vue-material-design-icons/ChevronRight'
import TimeIcon from 'vue-material-design-icons/Clock'
import AddIcon from 'vue-material-design-icons/PlusCircle'
import CheckIcon from 'vue-material-design-icons/CheckBold'
import BulkIcon from 'vue-material-design-icons/BriefcaseUploadOutline'
import EditIcon from 'vue-material-design-icons/PencilOutline'
import UpgradeIcon from 'vue-material-design-icons/SquareIncCash'
import MoneyIcon from 'vue-material-design-icons/CurrencyUsd'
import ListIcon from 'vue-material-design-icons/FormatListCheckbox'
import ReferIcon from 'vue-material-design-icons/AccountGroupOutline'
import InfoIcon from 'vue-material-design-icons/InformationOutline'

import i18n from '@/i18n'

Vue.component('home-icon', HomeIcon)
Vue.component('about-icon', AboutIcon)
Vue.component('pdf-icon', PdfIcon)
Vue.component('notifications-icon', NotificationsIcon)
Vue.component('business-icon', BusinessIcon)
// Vue.component('back-icon', BackIcon)
Vue.component('profile-icon', ProfileIcon)
Vue.component('settings-icon', SettingsIcon)
Vue.component('send-icon', SendIcon)
Vue.component('qr-icon', QrIcon)
Vue.component('help-icon', HelpIcon)
Vue.component('privacy-icon', PasswordIcon)
Vue.component('purse-icon', PurseIcon)
Vue.component('schedule-icon', ScheduleIcon)
Vue.component('search-icon', SearchIcon)
Vue.component('microphone-icon', MicrophoneIcon)
Vue.component('back-icon', BackIcon)
Vue.component('forward-icon', ForwardIcon)
Vue.component('up-icon', UpIcon)
Vue.component('menu-open-icon', MenuOpenIcon)
Vue.component('menu-close-icon', MenuCloseIcon)
Vue.component('sign-up-icon', SignUpIcon)
Vue.component('sign-in-icon', SignInIcon)
Vue.component('sign-out-icon', SignOutIcon)
Vue.component('email-icon', EmailIcon)
Vue.component('phone-icon', PhoneIcon)
Vue.component('sms-icon', SMSIcon)
Vue.component('password-icon', PasswordIcon)
Vue.component('confirm-icon', ConfirmIcon)
Vue.component('close-icon', CloseIcon)
Vue.component('new-icon', NewIcon)
Vue.component('upload-icon', UploadIcon)
Vue.component('sort-icon', SortIcon)
Vue.component('draggable-icon', DraggableIcon)
Vue.component('delete-icon', DeleteIcon)
Vue.component('remove-icon', RemoveIcon)
Vue.component('help-icon', HelpIcon)
Vue.component('collapse-icon', CollapseIcon)
Vue.component('rotate-icon', RotateIcon)
Vue.component('google-icon', GoogleIcon)
Vue.component('facebook-icon', FacebookIcon)
Vue.component('messenger-icon', MessengerIcon)
Vue.component('twitter-icon', TwitterIcon)
Vue.component('referral-icon', ReferralIcon)
Vue.component('translate-icon', TranslateIcon)
Vue.component('save-icon', SaveIcon)
Vue.component('star-icon', StarIcon)
Vue.component('fav-icon', FavIcon)
Vue.component('address-icon', AddressIcon)
Vue.component('web-icon', WebIcon)
Vue.component('device-icon', DeviceIcon)
Vue.component('title-icon', TitleIcon)
Vue.component('prev-icon', PrevIcon)
Vue.component('next-icon', NextIcon)
Vue.component('time-icon', TimeIcon)
Vue.component('add-icon', AddIcon)
Vue.component('check-icon', CheckIcon)
Vue.component('bulk-icon', BulkIcon)
Vue.component('edit-icon', EditIcon)
Vue.component('upgrade-icon', UpgradeIcon)
Vue.component('money-icon', MoneyIcon)
Vue.component('list-icon', ListIcon)
Vue.component('refer-icon', ReferIcon)
Vue.component('info-icon', InfoIcon)

Vue.config.productionTip = false
// Vue.config.silent = true

Vue.directive('focus', {
  inserted: el => el.focus()
})

Vue.directive('visible', {
  update: (el, binding, vnode) => {
    if ( binding.value ) el.style.opacity = 1
    else el.style.opacity = 0
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
